import useTranslation from "next-translate/useTranslation";
import type { IProduct } from "../types/products";

interface ITechnicalDetailsProps {
  product: IProduct;
}

export const ProductTechnicalDetails = ({
  product,
}: ITechnicalDetailsProps) => {
  const { t } = useTranslation("common");

  const details = [
    {
      key: "thermalIsolation",
      label: t("params.themralIsolation"),
      value:
        product.PVCDetails?.technicalDetails?.thermalIsolation ||
        product.en?.PVCDetails?.technicalDetails?.thermalIsolation,
    },
    {
      key: "tightness",
      label: t("params.tightness"),
      value:
        product.PVCDetails?.technicalDetails?.tightness ||
        product.en?.PVCDetails?.technicalDetails?.tightness,
    },
    {
      key: "acoustics",
      label: t("params.acoustics"),
      value:
        product.PVCDetails?.technicalDetails?.acoustics ||
        product.en?.PVCDetails?.technicalDetails?.acoustics,
    },
    {
      key: "security",
      label: t("functions.security"),
      value:
        product.PVCDetails?.technicalDetails?.security ||
        product.en?.PVCDetails?.technicalDetails?.security,
    },
    {
      key: "glazing",
      label: t("params.glazing"),
      value:
        product.PVCDetails?.technicalDetails?.glazing ||
        product.en?.PVCDetails?.technicalDetails?.glazing,
    },
    {
      key: "resistance",
      label: t("functions.resistance"),
      value:
        product.PVCDetails?.technicalDetails?.resistance ||
        product.en?.PVCDetails?.technicalDetails?.resistance,
    },
    {
      key: "waterprof",
      label: t("params.waterproof"),
      value:
        product.PVCDetails?.technicalDetails?.waterprof ||
        product.en?.PVCDetails?.technicalDetails?.waterprof,
    },
    {
      key: "grip",
      label: "Pochwyt",
      value:
        product.PVCDetails?.technicalDetails?.grip ||
        product.en?.PVCDetails?.technicalDetails?.grip,
    },
    {
      key: "decoration",
      label: "Zdobienie",
      value:
        product.PVCDetails?.technicalDetails?.decoration ||
        product.en?.PVCDetails?.technicalDetails?.decoration,
    },
    {
      key: "surface",
      label: "Powierzchnia",
      value:
        product.PVCDetails?.technicalDetails?.surface ||
        product.en?.PVCDetails?.technicalDetails?.surface,
    },
    {
      key: "others",
      label: t("params.other"),
      value:
        product.PVCDetails?.technicalDetails?.others ||
        product.en?.PVCDetails?.technicalDetails?.others,
    },
  ];

  return (
    <>
      {details.map(
        (detail) =>
          detail.value && (
            <div key={detail.key}>
              <span className="mr-1 text-orange">■</span>
              <strong className="uppercase">{detail.label}</strong>
              <br />
              <div className="ml-3">{detail.value}</div>
              <br />
            </div>
          )
      )}
    </>
  );
};
